import React, { useMemo, useState, useEffect } from "react";
import { PulseLoader } from "react-spinners";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { validEmail } from "../Constants/RegExp";
import { CreateCheckoutSession } from "./Requests";
import { CreateBooking } from "./Requests";
import { B2CGB } from "../Pages/OnlineBooking/B2CHTML-en-GB";
import { B2CES } from "../Pages/OnlineBooking/B2CHTML-es";
import { useTranslation } from "react-i18next";
import { formatMinor } from "../Components/Reusable/CurrencyFormatter/CurrencyFormatter";
import { Button } from "react-bootstrap";

const StepFour = (props) => {
  const { t } = useTranslation("makeBooking");

  const [firstName, setFirstName] = useState();
  const [lastName, setLastName]   = useState();
  const [email, setEmail]         = useState();
  const [mobile, setMobile]       = useState();
  const [sendReminder, setSendReminder] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);

  const bookingFormErrorsObj = { firstName: "", lastName: "", mobile: "", email: "" };
  const [formErrors, setFormErrors] = useState(bookingFormErrorsObj);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const resolvedHtml = useMemo(() => {
    let html = props.lang === "es" ? B2CES : B2CGB || "";
    if (props.shopName)  html = html.replaceAll("{{BUSINESS_NAME}}", props.shopName);
    if (props.emailForCustomer) html = html.replaceAll("{{BUSINESS_EMAIL}}", props.emailForCustomer);
    else html = html.replaceAll("{{BUSINESS_EMAIL}}", "email");
    return html;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.lang]);

  function OnFormSubmitClick(e, option) {
    e.preventDefault();
    const startDateTime = new Date(props.date).setHours(
      Number(props.time.split(":")[0]),
      Number(props.time.split(":")[1]),
      0, 0
    );

    let error = false;
    const errs = { ...bookingFormErrorsObj };

    if (!firstName) { errs.firstName = t("stepFour.errors.firstNameRequired"); error = true; }
    if (!lastName)  { errs.lastName  = t("stepFour.errors.lastNameRequired");  error = true; }

    if (mobile && mobile.length > 0 && mobile.length !== 11) {
      errs.mobile = t("stepFour.errors.invalidMobile");
      error = true;
    }

    if (!email) {
      errs.email = t("stepFour.errors.emailRequired"); error = true;
    } else if (!validEmail.test(email)) {
      errs.email = t("stepFour.errors.invalidEmail"); error = true;
    }

    setFormErrors(errs);
    if (error) return;

    setTimeout(() => window.scrollTo({ top: 0, behavior: "smooth" }));

    if (option === "book now") {
      setIsLoading(true);
      props.setEmail(email);
      CreateBooking(
        props.barber.barberId,
        props.service.serviceId,
        startDateTime,
        props.timeId,
        props.service.duration,
        firstName,
        lastName,
        email,
        mobile,
        sendReminder
      ).then((res) => {
        setIsLoading(false);
        if (res.status === 200) props.bookingResult("success");
        else props.bookingResult("failed");
      }).catch(() => {
        setIsLoading(false);
        props.bookingResult("failed");
      });
    } else {
      // pay now path
setIsLoading(true);
props.setEmail(email);
props.setFirstName(firstName);
props.setLastName(lastName);
props.setMobile(mobile);

CreateCheckoutSession(
  props.barber.barberId,
  props.service.serviceId,
  props.timeId,
  props.service.duration,
  firstName,
  lastName,
  email,
  mobile,
  props.date,
  props.time
)
  .then((res) => {
    if (res.status === 200 && res.data?.url) {
      window.location.href = res.data.url;
      return;
    }

    setIsLoading(false);
    props.bookingResult("failed");
  })
  .catch(() => {
    setIsLoading(false);
    props.bookingResult("failed");
  });
    }
  }

  const showTermsBlock =
    props.terms !== "" && props.terms != null && props.terms !== undefined;

  const requirePayment =
    !props.requirements &&
    props.acceptingOnlinePayments !== false &&
    props.service?.onlinePaymentAmount &&
    Number(props.service.onlinePaymentAmount) > 0;

  return (
    <div className="booking-portal-step-wrapper">
      <div className="details-shell">

        {/* Header */}
        <div className="details-head">
          <IconButton
            aria-label={t("stepFour.actions.back")}
            size="small"
            className="details-backBtn"
            onClick={() => props.goTo(2)}
          >
            <ArrowBackIcon className="details-backIcon" />
          </IconButton>
          <div className="details-titles">
            <h2 className="details-title">{t("stepFour.titles.confirmDetails")}</h2>
          </div>
        </div>

        {/* Content grid */}
        {
          isLoading ?
              <div className="" style={{display:"flex", justifyContent:"center"}}>
                <PulseLoader color={"#333"} loading={isLoading} size={15} aria-label={t("stepFour.status.loadingAria")} />
              </div>
              :
              null
        }
        <div className="details-grid">

          {/* Left: form card */}
            {!isLoading ? (
              
                        <div className="details-card">

              <form className="details-form" onSubmit={(e) => e.preventDefault()}>

                {/* Name row */}
                <div className="details-row">
                  <div className="details-group">
                    <label htmlFor="firstName">
                      {t("stepFour.labels.firstName")}<span>*</span>
                    </label>
                    <input
                      type="text"
                      id="firstName"
                      name="firstName"
                      required
                      placeholder={t("stepFour.placeholders.firstName")}
                      onChange={(e) => setFirstName(e.target.value)}
                    />
                    {formErrors.firstName && (
                      <div className="details-error">{formErrors.firstName}</div>
                    )}
                  </div>

                  <div className="details-group">
                    <label htmlFor="lastName">
                      {t("stepFour.labels.lastName")}<span>*</span>
                    </label>
                    <input
                      type="text"
                      id="lastName"
                      name="lastName"
                      required
                      placeholder={t("stepFour.placeholders.lastName")}
                      onChange={(e) => setLastName(e.target.value)}
                    />
                    {formErrors.lastName && (
                      <div className="details-error">{formErrors.lastName}</div>
                    )}
                  </div>
                </div>

                {/* Contact row */}
                <div className="details-row mt-3">
                  <div className="details-group">
                    <label htmlFor="email">
                      {t("stepFour.labels.email")}<span>*</span>
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      required
                      placeholder={t("stepFour.placeholders.email")}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    {formErrors.email && (
                      <div className="details-error">{formErrors.email}</div>
                    )}
                  </div>

                  <div className="details-group">
                    <label htmlFor="mobile">{t("stepFour.labels.mobile")}</label>
                    <input
                      type="tel"
                      id="mobile"
                      name="mobile"
                      placeholder={t("stepFour.placeholders.mobile")}
                      onChange={(e) => setMobile(e.target.value)}
                    />
                    {formErrors.mobile && (
                      <div className="details-error">{formErrors.mobile}</div>
                    )}
                  </div>
                </div>

                {/* Reminder */}
                <label htmlFor="showBusinessHoursCheck" className="reminder-check details-reminder">
                  <input
                    type="checkbox"
                    id="showBusinessHoursCheck"
                    defaultChecked={false}
                    onChange={(e) => setSendReminder(e.target.checked)}
                  />
                  <span style={{fontSize:"0.8rem"}}>{t("stepFour.labels.sendReminder")}</span>
                </label>

                {/* Consent */}
                    <p className="details-consent">
                      {t("stepFour.labels.consentPrefix")}{" "}
                      {showTermsBlock ? (
                        <>
                          <button
                            type="button"
                            className="details-link-inline"
                            onClick={() => setShowTerms(true)}
                            aria-label={t("stepFour.modals.terms.title")}
                          >
                            {t("stepFour.modals.terms.title")}
                          </button>
                          {" "}{t("stepFour.labels.and")}{" "}
                        </>
                      ) : null}
                      <button
                        type="button"
                        className="details-link-inline"
                        onClick={() => setShowPrivacy(true)}
                        aria-label={t("stepFour.modals.privacy.title")}
                      >
                        {t("stepFour.modals.privacy.title")}
                      </button>
                      .
                    </p>
              </form>
                        </div>

            ) : null}

          {/* Right: summary card */}
          {!isLoading ?
                    <aside className="details-side">
            <div className="summary-card">
              <h4 className="summary-title">{t("stepFour.titles.appointmentSummary")}</h4>
              <ul className="summary-meta">
                <li>
                  <span className="summary-label">{t("stepFour.labels.service")}</span>
                  <span className="summary-value">{props.service.name}</span>
                </li>
                <li>
                  <span className="summary-label">{t("stepFour.labels.staff")}</span>
                  <span className="summary-value">{props.barber.name}</span>
                </li>
                <li>
                  <span className="summary-label">{t("stepFour.labels.date")}</span>
                  <span className="summary-value">{new Date(props.date).toDateString()}</span>
                </li>
                <li>
                  <span className="summary-label">{t("stepFour.labels.time")}</span>
                  <span className="summary-value">{props.time}</span>
                </li>
                {props.service?.duration ? (
                  <li>
                    <span className="summary-label">{t("stepFour.labels.duration")}</span>
                    <span className="summary-value">
                      {props.serviceDurations.filter(item => item.value === props.service.duration)[0].label}
                    </span>
                  </li>
                ) : null}
                {props.acceptingOnlinePayments !== false && props.service?.onlinePaymentAmount ? (
                  <>
                  <li>
                    <span className="summary-label">{t("stepFour.labels.onlinePayment")}</span>
                    <span className="summary-value">
                      {formatMinor(props.service.onlinePaymentAmount, props.currency)}
                    </span>
                  </li>
                  <li>
                    <span className="summary-label">{t("stepFour.labels.payInShop")}</span>
                    <span className="summary-value">
                      {formatMinor(props.service.price - props.service.onlinePaymentAmount, props.currency)}
                    </span>
                  </li>
                  </>
                ) :
                  <li>
                    <span className="summary-label">{t("stepFour.labels.payInShop")}</span>
                    <span className="summary-value">
                      {formatMinor(props.service.price, props.currency)}
                    </span>
                  </li>
                }
              </ul>

              <div className="summary-actions">
                {(!props.service.onlinePaymentAmount ||
                  props.service.onlinePaymentAmount === 0.0 ||
                  props.acceptingOnlinePayments === false ||
                  props.requirements === true) ? (
                  <button
                    className="select-btn summary-btn"
                    onClick={(e) => OnFormSubmitClick(e, "book now")}
                    aria-label={t("stepFour.actions.bookNow")}
                  >
                    {t("stepFour.actions.bookNow")}
                  </button>
                ) : (
                  <button
                    className="select-btn summary-btn"
                    onClick={(e) => OnFormSubmitClick(e, "pay now")}
                    aria-label={t("stepFour.actions.payNow")}
                  >
                    {/* {t("stepFour.actions.payNow")} */}

                    {t("makeBooking:stepFive.actions.payAmount", {
                  amount: formatMinor(props.service.onlinePaymentAmount, props.currency),
                })}
                  </button>
                )}
              </div>
            </div>
          </aside>
          :
          null

          }

        </div>

        {/* Sticky action bar on mobile */}
        {/* <div className="details-sticky">
          {(!props.service.onlinePaymentAmount ||
            props.service.onlinePaymentAmount === 0.0 ||
            props.acceptingOnlinePayments === false ||
            props.requirements === true) ? (
            <button
              className="select-btn details-stickyBtn"
              onClick={(e) => OnFormSubmitClick(e, "book now")}
              aria-label={t("stepFour.actions.bookNow")}
            >
              {t("stepFour.actions.bookNow")}
            </button>
          ) : (
            <button
              className="select-btn details-stickyBtn"
              onClick={(e) => OnFormSubmitClick(e, "pay now")}
              aria-label={t("stepFour.actions.payNow")}
            >
              {t("stepFour.actions.payNow")}
            </button>
          )}
        </div> */}

        {/* TERMS MODAL */}
        {showTerms && (
          <div className="ap-modal__overlay" role="dialog" aria-modal="true" onClick={() => setShowTerms(false)}>
            <div className="ap-modal" onClick={(e) => e.stopPropagation()}>
              <div className="ap-modal__header">
                <h3>{t("stepFour.modals.terms.title")}</h3>
                <Button variant="" type="button" className="btn-close" onClick={() => setShowTerms(false)} aria-label={t("stepFour.modals.common.close")}></Button>
              </div>
              <div className="ap-modal__body">
                <pre className="ap-pre">{props.terms}</pre>
              </div>
              <div className="ap-modal__footer">
                <button className="pn-btn pn-btn-outline" onClick={() => setShowTerms(false)}>
                  {t("stepFour.modals.common.close")}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* PRIVACY MODAL */}
        {showPrivacy && (
          <div className="ap-modal__overlay" role="dialog" aria-modal="true" onClick={() => setShowPrivacy(false)}>
            <div className="ap-modal" onClick={(e) => e.stopPropagation()}>
              <div className="ap-modal__header">
                <h3>{t("stepFour.modals.privacy.title")}</h3>
                <Button variant="" type="button" className="btn-close" onClick={() => setShowPrivacy(false)} aria-label={t("stepFour.modals.common.close")}></Button>

              </div>
              <div className="ap-modal__body ap-privacy" dangerouslySetInnerHTML={{ __html: resolvedHtml }} />
              <div className="ap-modal__footer">
                <button className="pn-btn pn-btn-outline" onClick={() => setShowPrivacy(false)}>
                  {t("stepFour.modals.common.close")}
                </button>
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default StepFour;
